import { app } from '../../../../../../../bootstrap/core';

import { confirmWarrantPreviousAccountOptionsComponent } from './previousAccountOptions.component';

app.component(
  confirmWarrantPreviousAccountOptionsComponent.name,
  confirmWarrantPreviousAccountOptionsComponent,
);
